import { useState } from "react";
import { useIntl } from "react-intl";

import { MoreDetailsDrawer } from "@/components/MoreDetailsDrawer/MoreDetailsDrawer";
import { PaymentDetails, PaymentDetailsRow } from "@/components/PaymentDetails";
import { TermsAndConditionsAlert } from "@/components/TermsAndConditionsAlert/TermsAndConditionsAlert";
import { formatCurrency } from "@/utils/currency";

type Props = {
  basePrice: number;
  brandedFarePrice?: number;
  servicesPrice?: number;
  promoCodeDiscount?: number;
  totalPrice: number;
};

export const FlightOrderSummary = ({
  basePrice,
  brandedFarePrice,
  servicesPrice,
  promoCodeDiscount,
  totalPrice,
}: Props) => {
  const intl = useIntl();
  const [moreDetailsOpen, setMoreDetailsOpen] = useState(false);

  return (
    <>
      <PaymentDetails
        title={intl.formatMessage({
          defaultMessage: "Order Summary",
          description: "Title for the order summary section",
        })}
        totalPrice={formatCurrency(totalPrice)}
        footer={<TermsAndConditionsAlert />}
      >
        <PaymentDetailsRow
          label={intl.formatMessage({
            defaultMessage: "Base flight ticket",
            description:
              "Line item label for the base flight ticket price in the order summary",
          })}
          value={formatCurrency(basePrice)}
        />
        {brandedFarePrice ? (
          <PaymentDetailsRow
            label={intl.formatMessage({
              defaultMessage: "Branded fare",
              description:
                "Line item label for the branded fare price in the order summary",
            })}
            value={formatCurrency(brandedFarePrice)}
          />
        ) : null}
        {servicesPrice ? (
          <PaymentDetailsRow
            label={intl.formatMessage({
              defaultMessage: "Selected services",
              description:
                "Line item label for the selected services price in the order summary",
            })}
            value={formatCurrency(servicesPrice)}
          />
        ) : null}
        {promoCodeDiscount ? (
          <PaymentDetailsRow
            label={intl.formatMessage({
              defaultMessage: "Promo code discount",
              description:
                "Line item label for the promo code discount in the price summary",
            })}
            value={formatCurrency(promoCodeDiscount, undefined, {
              prefix: "-",
            })}
            color="accent"
          />
        ) : null}
      </PaymentDetails>

      <MoreDetailsDrawer
        open={moreDetailsOpen}
        onClose={() => setMoreDetailsOpen(false)}
      />
    </>
  );
};
